import { Dispatch, FC, SetStateAction } from 'react';
import classes from './styles.module.scss';
import { IInfrastructureProject } from '../../../types/project.types';
import { useTranslation } from 'react-i18next';
import AdditionalFields from '../components/additional-fields.component';
import StreetList from '../components/street-list.component';
import { isEmpty } from '../../../helpers/utils';

interface IProps {
    list: IInfrastructureProject[];
    isOpen: Record<string, boolean>;
    setIsOpen: Dispatch<SetStateAction<Record<string, boolean>>>;
}

const translationKey = 'projects.infrastructure-projects.village-road';

const VillageRoadTab: FC<IProps> = ({ list, isOpen, setIsOpen }) => {
    const { t } = useTranslation();

    const getPercentage = () => {
        const { totalStreetLength, lightenedStreetLength } = list[0] as IInfrastructureProject;
        if (!totalStreetLength || !lightenedStreetLength) return 0;
        if (isEmpty(totalStreetLength) || isEmpty(lightenedStreetLength) || +totalStreetLength === 0 || +lightenedStreetLength === 0) {
            return 0;
        }
        return ((+lightenedStreetLength / +totalStreetLength) * 100).toFixed(2) + '%';
    }

    const renderFieldRowItem = (labelKey: string, value: string | number | undefined, unit?: string) => (
        <div className={classes['field-row__item']}>
            <span className={classes['field-row__label']}>{t(labelKey)}:</span>
            <span className={classes['field-row__value']}>
                {value} {unit || ''}
            </span>
        </div>
    );

    return (
        list && list[0] && <div className={classes['items-list']}>
            <div className={classes['field-row']}>
                {['totalStreetNumber', 'totalStreetLength', 'lightenedStreetLength', 'lighteningCover'].map(field => {
                    const item = list[0];
                    const value = field === 'lighteningCover' ? getPercentage() : item[field as keyof IInfrastructureProject] as string | number | undefined;
                    const unit =
                        !['totalStreetLength', 'lightenedStreetLength'].includes(field)
                            ? ''
                            : t(`km`)
                    return renderFieldRowItem(`${translationKey}.${field}`, value, unit);
                })}
            </div>

            {list[0].additionalFields && <AdditionalFields data={list[0].additionalFields} />}

            {
                list[0].streetList && list[0].streetList.length > 0 && <StreetList
                    list={list[0].streetList}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                />
            }
        </div>
    );
};

export default VillageRoadTab;
